package io.eqoty.shared.viewmodel.screens.mintsong


actual object MimeTypes {
    actual val audio: List<String> = listOf(".flac", ".wav")
    actual val image: List<String> = listOf(".jpeg", ".jpg", ".png")
}
